import kebabCase from 'lodash/kebabCase';
import React from 'react';
import { Box } from '../../Box/Box';
import { Text } from '../../Text/Text';
/**
 * @public
 */
export const Section = ({
  heading,
  children
}) => React.createElement(Box, {
  my: 5
}, React.createElement(Text, {
  id: kebabCase(heading),
  textStyle: 'heading2',
  mb: 4
}, heading), children);